import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { Service } from '@core/models/home.model';

@Component({
  selector: 'd2d-service-card',
  templateUrl: './service-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './service-card.component.scss',
})
export class ServiceCardComponent {
  item = input.required<Service>();

  border = input<'primary' | 'oil'>('primary');
}
